import { CustomHeading, MainTextWrapper, NonLoginHeader, TextWrapper } from 'components'

export const PrivacyPolicyScreen = () => {
  return (
    <>
      <NonLoginHeader />
      <MainTextWrapper>
        <div className="d-flex align-items-center flex-column pt-4">
          <CustomHeading
            heading="Privacy Policy"
            subHeader="Agreement Between User and Website"
          />
          <TextWrapper>
            <h3>1. Terms</h3>
            <p>
              By accessing this Website, accessible from Website.com, you are
              agreeing to be bound by these Website Terms and Conditions of Use
              and agree that you are responsible for the agreement with any
              applicable local laws. If you disagree with any of these terms,
              you are prohibited from accessing this site. The materials
              contained in this Website are protected by copyright and trade
              mark law.
            </p>

            <h3>2. Use License</h3>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
            <p>
              Permission is granted to temporarily download one copy of the
              materials on Company Name's Website for personal, non-commercial
              transitory viewing only. This is the grant of a license, not a
              transfer of title, and under this license you may not:
            </p>
          </TextWrapper>
        </div>
      </MainTextWrapper>
    </>
  )
}
